<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="onSubmit")
    modal(active, title="Reabrir OS-m", @close="$router.back()")
      div(slot="modal-body")
        p Você está #[b reabrindo a OS-m], isso significa que a OS-m será reaberta para o fiscal.
        p Este processo #[b não é reversível].
        form-group(
          :label="'ordem_servico_analise.parecer' | tModel",
          :validation="$v.form.parecer"
        )
          textarea.form-input(
            rows="2",
            placeholder="Informe aqui o seu parecer",
            v-model.trim="$v.form.parecer.$model",
            v-autofocus
          )
      div(slot="modal-footer")
        button.btn(:disabled="$v.form.$invalid", :class="{ loading }")
          btn-content(icon="fa fa-check", label="Reabrir OS-m")
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import { minLength, required } from "vuelidate/lib/validators"

export default {
  vuex: {
    "analises/minhasAnalises": {
      getters: ["loading"],
      state: ["current"],
      actions: ["fetchUpdate"],
    },
  },
  data() {
    return {
      form: {
        parecer: "",
        situacao: "reabertura",
      },
    }
  },
  methods: {
    async onSubmit() {
      try {
        const data = { id: this.current.id, ...this.form }
        await this.fetchUpdate(data)
        this.$toaster.success("OS-m reaberta")
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  validations: {
    form: {
      parecer: { minLength: minLength(10), required },
      situacao: { required },
    },
  },
}
</script>
